<template>
    <BaseDialog :open="isConsentDialogOpen" title="Voice Chat" @update:open="(isOpen: boolean) => !isOpen && declineMicConsent()">
        <div class="flex flex-col gap-8 justify-start items-start py-6 md:py-10 px-4 md:px-10 md:min-w-100 md:max-w-140">
            <div class="flex flex-row gap-2.5 items-center">
                <i class="bi bi-mic-fill text-valence-primary-500" aria-hidden="true"></i>
                <h3 class="title-subsection">Voice Chat</h3>
            </div>

            <!-- Exact wording supplied by product/legal for the Workday rollout (ENG-1715) — do not
                 paraphrase without checking with them first. -->
            <p class="body-small text-valence-grey-750">
                By initiating a Voice Chat session, your voice input will be processed for the purpose of enabling Nadia to respond to your coaching queries. You may use text-based
                chat at any time.
            </p>

            <div class="flex flex-row gap-2.5 justify-end w-full">
                <BaseButton theme="tertiary" data-testid="mic-consent-decline" @click="declineMicConsent()">Not now</BaseButton>
                <BaseButton theme="primary" data-testid="mic-consent-accept" @click="acceptMicConsent()">Allow microphone</BaseButton>
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { useMicConsentDialog } from "~vue/composables/useMicConsent";

// Mounted once at the app root (see vue.js) so no mic surface has to remember to render it, and a
// page with several mic surfaces shows one dialog rather than one per surface.
const { isConsentDialogOpen, acceptMicConsent, declineMicConsent } = useMicConsentDialog();
</script>
